import { forwardRef, type ComponentProps, type ReactNode } from 'react';
import { Button } from '@src/design-system/button';
import { cn } from '@src/design-system/helpers';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@src/design-system/tooltip';

export type TableActionIconButtonProps = ComponentProps<typeof Button> & {
  label: string;
  icon: ReactNode;
  tooltipSide?: ComponentProps<typeof TooltipContent>['side'];
};

export const TableActionIconButton = forwardRef<
  HTMLButtonElement,
  TableActionIconButtonProps
>(function TableActionIconButton(
  {
    label,
    icon,
    className,
    size = 'iconSm',
    variant = 'primaryOutline',
    ...props
  },
  ref
) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          size={size}
          variant={variant}
          className={cn('text-gray-800', className)}
          aria-label={label}
          {...props}
        >
          {icon}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
});
